module.exports = __webpack_public_path__ + "static/media/trophyExplore.16dcc34f.png";